import desktop3MonthsCS from '../../../images/cs/3-mies-bezpromo_CZ_desktop.png';
import desktop3MonthsPromoCS from '../../../images/cs/3-mies-zpromo_CZ_desktop.png';
import desktop1MonthPromoCS from '../../../images/cs/1-mies-zpromo_CZ_desktop.png';
import desktop1MonthCS from '../../../images/cs/1-mies-bezpromo_CZ_desktop.png';
import desktop6MonthPromoCS from '../../../images/cs/6-mies-zpromo_CZ_desktop.png';
import desktop6MonthCS from '../../../images/cs/6-mies-bezpromo_CZ_desktop.png';

import desktop3MonthsSK from '../../../images/sk/3-mies-bezpromo_SK_desktop.png';
import desktop3MonthsPromoSK from '../../../images/sk/3-mies-zpromo_SK_desktop.png';
import desktop1MonthPromoSK from '../../../images/sk/1-mies-zpromo_SK_desktop.png';
import desktop1MonthSK from '../../../images/sk/1-mies-bezpromo_SK_desktop.png';
import desktop6MonthPromoSK from '../../../images/sk/6-mies-zpromo_SK_desktop.png';
import desktop6MonthSK from '../../../images/sk/6-mies-bezpromo_SK_desktop.png';

import desktop3MonthsHU from '../../../images/hu/3-mies-bezpromo_HU_desktop.png';
import desktop3MonthsPromoHU from '../../../images/hu/3-mies-zpromo_HU_desktop.png';
import desktop1MonthPromoHU from '../../../images/hu/1-mies-zpromo_HU_desktop.png';
import desktop1MonthHU from '../../../images/hu/1-mies-bezpromo_HU_desktop.png';
import desktop6MonthPromoHU from '../../../images/hu/6-mies-zpromo_HU_desktop.png';
import desktop6MonthHU from '../../../images/hu/6-mies-bezpromo_HU_desktop.png';

export const BANNER_DESKTOP_CONFIG = {
	cs: {
		basic: {
			promo: desktop1MonthPromoCS,
			normal: desktop1MonthCS,
		},
		pro: {
			promo: desktop3MonthsCS,
			normal: desktop3MonthsPromoCS,
		},
		premium: {
			promo: desktop6MonthPromoCS,
			normal: desktop6MonthCS,
		},
	},
	sk: {
		basic: {
			promo: desktop1MonthPromoSK,
			normal: desktop1MonthSK,
		},
		pro: {
			promo: desktop3MonthsSK,
			normal: desktop3MonthsPromoSK,
		},
		premium: {
			promo: desktop6MonthPromoSK,
			normal: desktop6MonthSK,
		},
	},
	hu: {
		basic: {
			promo: desktop1MonthPromoHU,
			normal: desktop1MonthHU,
		},
		pro: {
			promo: desktop3MonthsHU,
			normal: desktop3MonthsPromoHU,
		},
		premium: {
			promo: desktop6MonthPromoHU,
			normal: desktop6MonthHU,
		},
	},
};
